import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'
import 'font-awesome/css/font-awesome.css'
import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-92101741-1')
ReactGA.pageview(window.location.pathname)

ReactDOM.render(
  <App />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js